import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class ParFarRedAttribute extends Sensor {
  public parFarRedChart: any;
  private parFarRedSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.parFarRedChart = null;
    this.parFarRedSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }
      this.ensureArraySize(this.parFarRedSensor, position);
      this.parFarRedSensor[position].push([timestamp, element.parFarRed]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredParFarRed = this.parFarRedSensor.filter(series => series.length > 0);

    const positionNodeParFarRed = this.parFarRedSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.parFarRedChart = this.getConfigChar(
      'parFarRed',
      this.getChartSeriesNewNode('Sensor', filteredParFarRed, positionNodeParFarRed),
      this.getRanges('parFarRed'),
      this.getLimits('parFarRed')
    );
  }

  public hasParFarRedSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.parFarRedSensor.length &&
      this.parFarRedSensor[index].length > 0
    );
  }

  public getParFarRedSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.parFarRedSensor.length) {
      const sensorData = this.parFarRedSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'PAR Far Red', value: 'parFarRed' }
    ];
  }
}
